import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-TW'
import jaLocale from 'element-ui/lib/locale/lang/ja'
import koLocale from 'element-ui/lib/locale/lang/ko'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}

  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      // 初始化語系
      if (!messages[locale]) messages[locale] = {}
      // 檢查是否有區分功能翻譯
      const subfolderLocales = key.split('/')
      if (subfolderLocales.length > 2) {
        const subKey = subfolderLocales[1]
        Object.assign(messages[locale], { [subKey]: locales(key) })
      } else {
        Object.assign(messages[locale], locales(key))
      }
    }
  })
  // 加入element国际化语系
  messages['en'] = {...messages['en'], ...enLocale}
  messages['ja'] = {...messages['ja'], ...jaLocale}
  messages['ko'] = {...messages['ko'], ...koLocale}
  messages['zh-tw'] = {...messages['zh-tw'], ...zhLocale}
  return messages
}


const locale = localStorage.getItem('lang') || 'zh-tw'
export default new VueI18n({
  locale,
  messages: loadLocaleMessages()
})
